import React, {Component} from 'react';
import UserAccount from './UserAccountHeaderComponent/UserAccount';

class HeaderNav extends Component {

    render() {
        return (
            <div className="">
                <header className="main-header">
                    <nav className="navbar navbar-static-top" style={window.location.pathname === "/wlmgHome" ? {marginLeft:"0px"}: {}}>

                        {
                            window.location.pathname !== "/wlmgHome" ? <a href="" className="sidebar-toggle" data-toggle="push-menu" role="button">
                                <span className="sr-only">Toggle navigation</span>
                            </a> : <span />
                        }


                        <div className="navbar-custom-menu">
                            <ul className="nav navbar-nav">
                                <UserAccount/>
                            </ul>
                        </div>
                    </nav>
                </header>
            </div>
        );
    }
}

export default HeaderNav;
